import { render, staticRenderFns } from "./ac-swatches.vue?vue&type=template&id=0306eff0&"
import script from "./ac-swatches.vue?vue&type=script&lang=js&"
export * from "./ac-swatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports